module.exports = __webpack_public_path__ + "static/media/ic_add_circle.7c1b9060.svg";